import 'swiper/swiper-bundle.css'
import './scss/vitrine.scss'

import { Swiper, SwiperSlide } from "swiper/react"
import { Device } from "../../data/device"
import type { QuatroItensBlackProps } from "../../types/vitrineApp.props"
import { ProdutoCard } from "./components/ProdutoCard"
import { Navigation, Autoplay } from 'swiper/modules'
import { TitleCtn } from '../../components/TitleCtn'

export function QuatroItensBlack({
    vitrineMacro,
    hostImagem,
    tituloVitrine,
    produtos,
    autoPlayVitrine,
    usaCarrossel,
    validaTempoVitrine,
    exibeVitrineFull,
    exibeQuantidadeEstoque,
    itensVisiveisDesktop,
    itensVisiveisTablet,
    itensVisiveisMobile,
    exibeValoresSomenteLogado,
    precoPrincipal,
    condicaoParcelamento,
    device,
    vitrineButtonAddToCart,
    zordHintLoading,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    width,
    height
}: Readonly<QuatroItensBlackProps>) {
    const items = {
        'desktop': itensVisiveisDesktop ? itensVisiveisDesktop : '4',
        'tablet': itensVisiveisTablet ? itensVisiveisTablet : '2.2',
        'mobile': itensVisiveisMobile ? itensVisiveisMobile : '1.2'
    }

    const isMobile = device === Device.MOBILE
    const isTablet = device === Device.TABLET
    const isApp = device === Device.APP
    const isDesktop = ![Device.MOBILE, Device.TABLET, Device.APP].includes(device)

    const hasCustomItems = Boolean(itensVisiveisDesktop || itensVisiveisTablet || itensVisiveisMobile)
    const computedSlidesPerView =  isTablet && (!isMobile || !isApp) ? Number(items.tablet) : isMobile || isApp || isTablet ? Number(items.mobile) : isDesktop ? Number(items.desktop) : 1
    const computedSpaceBetween = isTablet || isMobile || isApp ? 8 : 16

    return (
        <>
            <TitleCtn tituloVitrine={tituloVitrine} />

            <div className={`container ${exibeVitrineFull ? 'vitrine-full' : ''}`}>
                <div className={`macro-vitrine-4-itens-black ${vitrineMacro}`}>
                    {usaCarrossel ? (
                        <Swiper
                            className={`swiper-vitrine-11-${vitrineMacro}`}
                            modules={[Navigation, Autoplay]}
                            navigation={isDesktop ? {
                                nextEl: `.swiper-button-next-${vitrineMacro}`,
                                prevEl: `.swiper-button-prev-${vitrineMacro}`
                            } : false}
                            rewind
                            {...(autoPlayVitrine
                                ? {
                                    autoplay: {
                                        pauseOnMouseEnter: true,
                                    },
                                }
                                : {}
                            )}
                            {...(hasCustomItems
                                ? {
                                    slidesPerView: computedSlidesPerView,
                                    spaceBetween: computedSpaceBetween,
                                }
                                : {
                                    breakpoints: {
                                        0: { slidesPerView: 1.2, spaceBetween: 8 },
                                        520: { slidesPerView: 2.2, spaceBetween: 8 },
                                        1024: { slidesPerView: 4, spaceBetween: 16 },
                                    },
                                }
                            )}
                        >
                            {Object.values(produtos).map((produto, index) => (
                                <SwiperSlide className={produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}>
                                    <ProdutoCard
                                        hostImagem={hostImagem}
                                        produto={produto}
                                        index={index}
                                        precoPrincipal={precoPrincipal}
                                        condicaoParcelamento={condicaoParcelamento}
                                        validaTempoVitrine={validaTempoVitrine}
                                        zordHintLoading={zordHintLoading}
                                        device={device}
                                        vitrineButtonAddToCart={vitrineButtonAddToCart}
                                        exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                        exibeQuantidadeEstoque={exibeQuantidadeEstoque}
                                        width={width}
                                        height={height}
                                        hoverImagensVitrine={hoverImagensVitrine}
                                        hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                        utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                    />
                                </SwiperSlide>
                            ))}

                            {isDesktop && (
                                <>
                                    <div className={`swiper-button-prev swiper-button-prev-${vitrineMacro}`}></div>
                                    <div className={`swiper-button-next swiper-button-next-${vitrineMacro}`}></div>
                                </>
                            )}
                        </Swiper>
                    ) : (
                        <div className="product-wrapper flex row no-carousel">
                            {Object.values(produtos).map((produto, index) => (
                                <div className={produto.qtde_estoque > 0 ? 'in_stock' : 'out_stock'}>
                                    <ProdutoCard
                                        hostImagem={hostImagem}
                                        produto={produto}
                                        index={index}
                                        precoPrincipal={precoPrincipal}
                                        condicaoParcelamento={condicaoParcelamento}
                                        validaTempoVitrine={validaTempoVitrine}
                                        zordHintLoading={zordHintLoading}
                                        device={device}
                                        vitrineButtonAddToCart={vitrineButtonAddToCart}
                                        exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                        exibeQuantidadeEstoque={exibeQuantidadeEstoque}
                                        width={width}
                                        height={height}
                                        hoverImagensVitrine={hoverImagensVitrine}
                                        hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                        utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                    />
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}